import React, { useState } from "react"
import PropTypes from "prop-types"
import NavigationDesktop from "./Navigation/Desktop/Navigation"
import TopNavigationDesktop from "./Navigation/Desktop/TopNavigation"
import NavigationMobile from "./Navigation/Mobile/Navigation"
import { gaLogo, gaLogoLabel } from "../../../constants/gtm.constants"
import * as styles from "./Header-tw-styles"
import Link from "../../UI/Link/Link"
import { checkForInjection } from "../../../helpers/search"
import useImage from "../../../hooks/useImage"
import {
  labels,
  SEARCH_FIELD,
  jumpToHeader,
} from "../../../constants/label.constants"
import Image from "../../UI/Image/Image"
import { useStaticQuery, graphql } from "gatsby"
import useScreenSize from "../../../hooks/useScreenSize"

const Header = props => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulHeader {
          nodes {
            navigation {
              label
              link {
                ariaLabel
                gaEventClass
                gaEventLabel
                label
                title
                url
                target
                scrollToElementId
              }
              dropdownItems {
                label
                link {
                  ariaLabel
                  gaEventClass
                  gaEventLabel
                  label
                  title
                  url
                  target
                  scrollToElementId
                }
                variant
                dropdownItems {
                  label
                  link {
                    ariaLabel
                    gaEventClass
                    gaEventLabel
                    label
                    title
                    url
                    target
                    scrollToElementId
                  }
                  variant
                  dropdownItems {
                    label
                    link {
                      ariaLabel
                      gaEventClass
                      gaEventLabel
                      label
                      title
                      url
                      target
                      scrollToElementId
                    }
                    variant
                  }
                }
              }
            }
            topNavigation {
              label
              link {
                ariaLabel
                gaEventClass
                gaEventLabel
                label
                title
                url
                target
                scrollToElementId
              }
              dropdownItems {
                label
                link {
                  ariaLabel
                  gaEventClass
                  gaEventLabel
                  label
                  title
                  url
                  target
                  scrollToElementId
                }
                variant
                dropdownItems {
                  label
                  link {
                    ariaLabel
                    gaEventClass
                    gaEventLabel
                    label
                    title
                    url
                    target
                    scrollToElementId
                  }
                  variant
                  dropdownItems {
                    label
                    link {
                      ariaLabel
                      gaEventClass
                      gaEventLabel
                      label
                      title
                      url
                      target
                      scrollToElementId
                    }
                    variant
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const { logoImg, hideHeader } = props
  const screen = useScreenSize()
  let queryParams = ""
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false)
  const [isFieldExpanded, setIsFieldExpanded] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [searchError, setSearchError] = useState("")
  const navigationData =
    data?.allContentfulHeader?.nodes[0]?.navigation.length > 0
      ? data?.allContentfulHeader?.nodes[0]?.navigation
      : []
  const topNavigationData =
    data?.allContentfulHeader?.nodes[0]?.topNavigation.length > 0
      ? data?.allContentfulHeader?.nodes[0]?.topNavigation
      : []

  const { altText, foregroundImg } = useImage(logoImg)
  const style = styles.defaultStyle
  const { headerContainer, headerContent, headerContentInner } = style
  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen)
  }
  const handleSearch = e => {
    setSearchError("")
    setSearchTerm(e.target.value)
  }

  const handleSearchSubmit = () => {
    if (!checkForInjection(searchTerm)) {
      setSearchError("Please enter valid search term")
    } else {
      queryParams = `${SEARCH_FIELD.link}` + searchTerm
      history.pushState({}, "", queryParams)
      location.reload()
    }
  }

  const onKeyDown = e => {
    if (e.key === "Enter" && searchTerm) {
      handleSearchSubmit()
    }
  }

  return (
    <div className={headerContainer} id={jumpToHeader}>
      {screen && !screen.isMobile && (
        <div className="forDesktopHeader">
          {!hideHeader && (
            <TopNavigationDesktop navigation={topNavigationData} />
          )}
        </div>
      )}

      <div className={headerContent} role="banner">
        <div className="content-container">
          <div className={headerContentInner}>
            <div className="formobileHeader">
              {" "}
              {!hideHeader && (
                <button
                  className={
                    !isFieldExpanded ? "icon-search" : "icon-right-arrow"
                  }
                  role="button"
                  aria-label={SEARCH_FIELD.ariaLabel1}
                  onClick={() => setIsFieldExpanded(!isFieldExpanded)}
                ></button>
              )}
              <div className={style?.brandLogo}>
                <Link
                  url={labels?.urls?.homepage}
                  title={labels?.header?.homepage}
                  gaEventClass={gaLogo}
                  gaEventLabel={gaLogoLabel}
                >
                  <Image
                    className={style?.logoImgs}
                    contentfulImage={foregroundImg}
                    alt={altText}
                    width={labels?.header?.logo?.width}
                    height={labels?.header?.logo?.height}
                    eventClass={gaLogo}
                    eventLabel={gaLogoLabel}
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <>
          <div className="formobileHeader">
            {!hideHeader && (
              <NavigationMobile
                navigation={navigationData}
                topNavigation={topNavigationData}
                isMobileNavOpen={isMobileNavOpen}
                toggleMobileNav={toggleMobileNav}
                logoImg={logoImg}
              />
            )}
          </div>
        </>
        <div className="forDesktopHeader">
          {hideHeader ? (
            <NavigationDesktop logoImg={logoImg} />
          ) : (
            <NavigationDesktop navigation={navigationData} logoImg={logoImg} />
          )}
        </div>
      </div>
      {screen && screen.isMobile && (
        <div
          role="search"
          aria-label="search-input-box"
          className={
            isFieldExpanded
              ? `${style?.searchBarM} active`
              : `${style?.searchBarM}`
          }
        >
          <div className={style?.searchBarContainerM}>
            <div className={style?.colofSearchM}>
              <input
                id="global_search"
                type="text"
                placeholder={SEARCH_FIELD.placeholder}
                aria-label={SEARCH_FIELD.ariaLabel2}
                value={searchTerm}
                onChange={handleSearch}
                onKeyDown={onKeyDown}
                data-testid="gloabalSearch"
              />
              <button
                type="button"
                aria-label={SEARCH_FIELD.ariaLabel3}
                className={style?.searchButtonM}
                onClick={handleSearchSubmit}
                data-testid="search"
              ></button>
              {searchError && <p className="text-red-600 mt-1">{searchError}</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

Header.propTypes = {
  logoImg: PropTypes.object,
  hideHeader: PropTypes.bool,
}

export default Header
